<script>
import router from "../../router";
export default {
  name: "AddAccessRight",
  data() {
    return {
      owner: false,
      pos_access: false,
      back_office_access: false,
      client: {
        shifts: false,
        time_clock: false,
        open_tickets: false,
        kitchen_printers: false,
        customer_display: false,
        dining_options: false,
        user_define_tickets: false,
        low_stock: false,
        negative_stock_alerts: false
      },
      role: {
        id: null,
        name: "",
        pos: false,
        back_office: false,
        menu_app: false,
        apply_discount_restricted: false,
        view_all_receiptis: false,
        manage_open_tickets: false,
        saved_open_tickets: false,
        shift_report: false,
        change_tax: false,
        purchase_returns: false,
        open_cash_drawer: false,
        edit_items: false,
        change_setting: false,
        access_livechat: false,
        menu_reports: false,
        menu_employees: false,
        menu_customers: false,
        manage_stores: false,
        manage_transfer_order: false,
        access_jubelio: false,
        edit_profile: false,
        menu_items: false,
        manage_access_right: false,
        manage_billing: false,
        set_payment_type: false,
        set_taxes: false,
        manage_pos: false,
        kitchen_printer: false,
        dining_option: false,
        support: false,
        is_menu_app: false,
        manage_online_storefront: false,
        process_online_storefront_order: false,
        access_all_processed_orders: false,
        bo_manage_online_storefront: false
      }
    };
  },
  methods: {
    details(id) {
      this.role = {};

      this.$api
        .getAPI({
          _action: "/role/detail/" + id
        })
        .then(res => {
          this.role = res;
          if (this.role.name == "OWNER") {
            this.owner = true;
          }
          this.checkPosBack();
        });
    },
    save() {
      this.$api
        .postAPI({
          _action: "/role/",
          _body: this.role,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });

          router.push("/access-rights");
        })
        .catch(e => {});
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },
    checkPosBack() {
      if (this.role.pos) {
        this.pos_access = true;
      } else {
        this.pos_access = false;
      }
      if (this.role.back_office) {
        this.back_office_access = true;
      } else {
        this.back_office_access = false;
      }
    },
    updateAccessAllProccessedOrder() {
      if (!this.role.process_online_storefront_order) {
        this.role.access_all_processed_orders = false;
      }
    },
    generalSetting() {
      this.client = {};

      this.$api
        .getAPI({
          _action: "/backoffice-setting/general"
        })
        .then(res => {
          this.client = res;
          localStorage.setItem("dining_options", this.client.dining_options);
          localStorage.setItem("customer_sharing", this.client.customer_sharing);
          localStorage.setItem("is_enable_b2b", this.client.is_enable_b2b);
        });
    },
    onChangeMenuItems(){
      if(!this.role.menu_items){
        this.role.manage_transfer_order = false;
      }

    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
    this.generalSetting();
  }
};
</script>
<template>
  <div class="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <div class="card rounded-5 p-3 border">
            <div class="card-body form-style">
              <div class="row">
                <div class="col-lg-12 mb-4">
                  <label for class="font-20">{{$lang.messages.role}}</label>
                  <span style="color:#ff0000">*</span>
                  <input
                    name="name"
                    v-model="role.name"
                    v-validate="'required|max:300'"
                    class="form-control"
                    maxlength="300"
                    :class="{'input': true, 'is-danger': errors.has('name') }"
                    type="text"
                    v-bind:placeholder="$lang.messages.name"
                    :disabled="owner"
                  />
                  <i v-show="errors.has('name')" class="fa fa-warning"></i>
                  <span
                    v-show="errors.has('name')"
                    class="help is-danger"
                  >{{$lang.messages.please_enter_valid_name}}</span>
                </div>

                <div class="col-lg-9 col-9">
                  <h3>{{$lang.messages.pos}}</h3>
                </div>

                <div class="col-lg-3 col-3 text-right">
                  <div class="form-group">
                    <span class="switch switch-sm">
                      <input
                        type="checkbox"
                        class="switch"
                        v-model="role.pos"
                        :disabled="owner"
                        id="switch-sm"
                        @change="checkPosBack()"
                      />
                      <label for="switch-sm"></label>
                    </span>
                  </div>
                </div>
                <div v-if="pos_access">
                  <div class="col-lg-12 mt-4 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-1"
                        v-model="role.view_all_receiptis"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-1">
                        {{$lang.messages.view_all_receipts}}
                        <br />
                        <small
                          class="text-grey"
                        ></small>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-2"
                        v-model="role.apply_discount_restricted"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-2"
                      >{{$lang.messages.apply_discounts_with_restricted_access}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-4"
                        v-model="role.purchase_returns"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-4"
                      >{{$lang.messages.carry_out_purchasing_returns}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-21"
                        v-model="role.shift_report"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-21"
                      >{{$lang.messages.view_shift_report}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-6"
                        v-model="role.edit_items"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-6"
                      >{{$lang.messages.edit_items}}</label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-36"
                        v-model="role.manage_online_storefront"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-36">
                        {{$lang.messages.manage_online_storefront}}
                      </label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-38"
                          v-model="role.process_online_storefront_order"
                        @change="updateAccessAllProccessedOrder()"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-38">
                        {{$lang.messages.process_online_storefront_order}}
                      </label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-37"
                          v-model="role.access_all_processed_orders"
                        :disabled="owner || !role.process_online_storefront_order"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-37">
                        {{$lang.messages.access_all_processed_orders}}
                      </label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-7"
                        v-model="role.change_setting"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-7"
                      >{{$lang.messages.change_settings}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-9 col-9">
                  <h3>{{$lang.messages.back_office}}</h3>
                </div>
                <div class="col-lg-3 col-3 text-right">
                  <div class="form-group">
                    <span class="switch switch-sm">
                      <input
                        type="checkbox"
                        class="switch"
                        id="BackOffice"
                        v-model="role.back_office"
                        :disabled="owner"
                        @change="checkPosBack()"
                      />
                      <label for="BackOffice"></label>
                    </span>
                  </div>
                </div>
                <div v-if="back_office_access">
                  <div class="col-lg-12 mb-4 mt-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-9"
                        v-model="role.menu_reports"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-9">
                        {{$lang.messages.reports}}
                        <br />
                        <small class="text-grey">{{$lang.messages.view_sales_reports}}</small>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-35"
                        v-model="role.create_items"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-35">
                        {{$lang.messages.create_items}}
                        <br />
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-10"
                        v-model="role.menu_items"
                        :disabled="owner"
                        @change="onChangeMenuItems()"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-10">
                        {{$lang.messages.manage_items_inventory}}
                        <br />
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-32"
                        :disabled="owner || !role.menu_items"
                        v-model="role.manage_transfer_order"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-32"
                      >{{$lang.messages.manage_transfer_order}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-34"
                        v-model="role.manage_access_right"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-34">
                        {{$lang.messages.access_rights}}
                        <br />
                        <small class="text-grey">{{$lang.messages.manage_roles}}</small>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-11"
                        v-model="role.menu_employees"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-11">
                        {{$lang.messages.employees}}
                        <br />
                        <small class="text-grey">{{$lang.messages.manage_employees}}</small>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-12"
                        v-model="role.menu_customers"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-12">
                        {{$lang.messages.customers}}
                        <br />
                        <small class="text-grey">{{$lang.messages.access_to_customer_base}}</small>
                      </label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <p class="font-18 f-semi-bold">{{$lang.messages.settings}}</p>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-30"
                        :disabled="owner"
                        v-model="role.access_jubelio"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-30"
                      >{{$lang.messages.access_to_jubelio}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-31"
                        :disabled="owner"
                        v-model="role.edit_b2b_store"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-31"
                      >{{$lang.messages.edit_b2b_store}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-13"
                        v-model="role.edit_profile"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-13"
                      >{{$lang.messages.edit_profile}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-26"
                        v-model="role.view_account_information"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-26"
                      >{{$lang.messages.view_account_information}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-25"
                        v-model="role.edit_account_information"
                        :disabled="true"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-25"
                      >{{$lang.messages.edit_account_information}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-14"
                        v-model="role.manage_billing"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-14"
                      >{{$lang.messages.manage_subscription}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-15"
                        v-model="role.set_payment_type"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-15"
                      >{{$lang.messages.set_the_payment_types}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4" v-if="client.dining_options">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-23"
                        v-model="role.dining_option"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-23"
                      >{{$lang.messages.manage_dining_options}}</label>
                    </div>
                  </div>
                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-33"
                        v-model="role.manage_stores"
                        :disabled="owner"
                      />
                      <label
                        class="custom-control-label text-dark ml-2"
                        for="checkbox-33"
                      >{{$lang.messages.manage_stores}}</label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-100"
                        v-model="role.bo_manage_online_storefront"
                        :disabled="owner"/>
                      <label class="custom-control-label text-dark ml-2" for="checkbox-100">
                        {{$lang.messages.manage_online_storefront_cap}}
                      </label>
                    </div>
                  </div>

                  <div class="col-lg-12 mb-4">
                    <div class="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="checkbox-18"
                        v-model="role.manage_pos"
                        :disabled="owner"
                      />
                      <label class="custom-control-label text-dark ml-2" for="checkbox-18">
                        {{$lang.messages.manage_pos_devices}}
                      </label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-9 col-9" v-if="client.is_menu_app">
                  <h3>{{$lang.messages.menu_app}}</h3>
                  <p
                    class="text-grey font-14"
                  >{{$lang.messages.employees_can_log_in_to_the_menu_app_using_their_email_and_password}}</p>
                </div>
                <div class="col-lg-3 col-3 text-right" v-if="client.is_menu_app">
                  <div class="form-group">
                    <span class="switch switch-sm">
                      <input
                        type="checkbox"
                        class="switch"
                        id="menuapp"
                        v-model="role.menu_app"
                        :disabled="owner"
                      />
                      <label for="menuapp"></label>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 text-lg-right text-center">
          <button
            type="button"
            class="btn btn-primary mr-3"
            @click="validateForm()"
            id="save-btn"
          >{{$lang.messages.save_btn_text}}</button>
          <button
            type="button"
            class="btn btn-outline-primary"
            @click="$router.go(-1)"
          >{{$lang.messages.cancel_btn_text}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
